import React from 'react';
import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import PlumSvg from '../../pages/component/PlumSvg';

const PlumLoader = () => {
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%)',
          animation: 'pulse 4s ease-in-out infinite',
        },
      }}
    >
      <Box 
        sx={{ 
          position: 'relative', 
          display: 'inline-flex',
          zIndex: 1,
        }}
      >
        <CircularProgress
          size={100}
          thickness={3}
          sx={{ 
            color: 'white',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
            },
          }}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            animation: 'pulse 2s ease-in-out infinite',
          }}
        >
          <Box
            sx={{
              background: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '50%',
              p: 2,
              backdropFilter: 'blur(10px)',
            }}
          >
            <PlumSvg width={48} height={48} />
          </Box>
        </Box>
      </Box>
      <Typography
        variant="h6"
        sx={{
          mt: 3,
          color: 'white',
          fontWeight: 600,
          letterSpacing: '1px',
          animation: 'fadeIn 1s ease-out',
          zIndex: 1,
        }}
      >
        Загрузка...
      </Typography>
    </Box>
  );
};

export default PlumLoader;
